export const LengthConstraints: any = {
    firstName: 100,
    lastName: 100,
    default: 4000,
};
